import { Component, inject, NgZone, OnInit } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Header } from '@app/header/header';
import { AuthService } from '@app/auth/auth.service';
import { Title } from '@angular/platform-browser';
import { filter, map } from 'rxjs/operators';
import { LoadingOverlayComponent } from '@app/shared/loading-overlay/loading-overlay.component';
import { RouteHistoryService } from '@app/route-history.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    CommonModule,
    Header,
    LoadingOverlayComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private titleService = inject(Title);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private authService = inject(AuthService);
  private ngZone = inject(NgZone);
  private routeHistory = inject(RouteHistoryService);

  hideTopBar = false;

  constructor() {
    this.updateTitleOnRouteChange();
  }

  ngOnInit(): void {
    this.routeHistory.startTracking();

    window.addEventListener('storage', (event: StorageEvent) => {
      if (event.key === 'auth_token' && !event.newValue) {
        this.ngZone.run(() => {
          this.router.navigate(['/login']);
          window.location.reload();
        });
      }

      if (event.key === 'login_event' && event.newValue) {
        this.ngZone.run(() => {
          this.router.navigateByUrl(this.routeHistory.getLastUrl());
          localStorage.removeItem('login_event');
        });
      }
    });
  }

  public showTopBar(): boolean {
    return this.authService.isAuthenticated() && !this.hideTopBar;
  }

  public getStyle(): string {
    return this.authService.isAuthenticated() ? 'main' : '';
  }

  private updateTitleOnRouteChange(): void {
    const defaultTitle = 'Admin Panel';

    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(() => {
        let route = this.activatedRoute;

        while (route.firstChild) {
          route = route.firstChild;
        }

        this.hideTopBar = route.snapshot.data['hideTopBar'] === true;

        return route.snapshot.data['title'] || defaultTitle;
      })
    ).subscribe((title) => {
      this.titleService.setTitle(title);
    });
  }
}